var WizFile = /** @class */ (function () {
    function WizFile(inputData) {
        var data = inputData || {};
        this.id = data['id'];
        this.name = data['name'];
        this.dateCreated = data['dateCreated'] ? new Date(data['dateCreated']) : undefined;
        this.domFile = data['domFile'];
    }
    return WizFile;
}());
export { WizFile };
